import * as React from 'react';
import * as accounting from 'accounting';
import * as moment from 'moment';
import * as I18n from 'i18n-js';
import BumpSetup from './bump_setup';
import BumpChange from './bump_change';
import { Props as BumpBidSliderProps } from './bump_bid_slider';
import { CoreBumpListingCard } from '../../schemas/rql';

interface Props {
  productId: string;
  bidTiers: Array<string>[];
  tierIncrement: number;
  bid?: number;
  adminBid?: any;
  impressions?: number;
  salesCount?: number;
  salesSpent?: string;
  salesRevenue?: string;
  averagePosition?: number;
  listingPrice?: CoreBumpListingCard.SellerPrice;
  shippingPrice?: CoreBumpListingCard.OriginalRate;
  hasInventory?: boolean;
  error: boolean;
  didBidChange: boolean;
  onBidChange: Function;
  isNewCondition: boolean;
  sliderToggle: Function;
  updateBid: Function;
  changeDismiss: Function;
  showMobileSlider: boolean;
  selectedBid: number;
  deleted: boolean;
}

function bumpBidSliderProps(props) {
  const sliderProps: BumpBidSliderProps = {
    bidTiers: props.bidTiers,
    tierIncrement: props.tierIncrement,
    bid: props.selectedBid,
    setBid: props.bid,
    updateBid: props.updateBid,
    onBidChange: props.onBidChange,
    error: props.error,
    didBidChange: props.didBidChange,
    changeDismiss: props.changeDismiss,
    deleted: props.deleted,
  };

  return (sliderProps);
}

function shouldShowStats(props) {
  return props.bid ||
    props.salesCount ||
    accounting.unformat(props.salesSpent) ||
    accounting.unformat(props.salesRevenue);
}

function content(props) {
  if (shouldShowStats(props)) {
    return (
      <BumpChange
        bumpBidSliderProps={bumpBidSliderProps(props)}
        impressions={props.impressions || 0}
        salesCount={props.salesCount || 0}
        salesSpent={props.salesSpent || '0'}
        salesRevenue={props.salesRevenue || '0'}
        showMobileSlider={props.showMobileSlider}
        sliderToggle={props.sliderToggle}
        currentBid={props.selectedBid}
        hasInventory={props.hasInventory}
      />
    );
  }

  return (
    <BumpSetup
      bumpBidSliderProps={bumpBidSliderProps(props)}
      listingPrice={props.listingPrice}
      shippingPrice={props.shippingPrice}
      isNewCondition={props.isNewCondition}
      showMobileSlider={props.showMobileSlider}
      sliderToggle={props.sliderToggle}
    />
  );
}

function adminBidMessage(props) {
  const { adminBid } = props;
  if (!(adminBid && adminBid.bid)) { return null; }

  return (
    <h1 className="product-bump__admin-bump-header">
      {I18n.t('discovery.bump.adminBump', {
        percentage: adminBid.bid * 100,
        expirationDate: moment(adminBid.expiresAt).format('MMMM D'),
      })}
    </h1>
  );
}

function ProductPageBump(props: Props) {
  return (
    <div>
      {adminBidMessage(props)}
      {content(props)}
    </div>
  );
}

export default ProductPageBump;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/product_page_bump.tsx